import React from 'react'
import { getBadgeTheme, getProductTag } from '@helpers/products'
import { PRODUCT_COLOUR_TAGS } from '@consts/index'
import Badge from '@components/ui/Badge'
import styles from './styles.module.scss'

type CollectionTagsProps = {
  tags: string[]
}

function CollectionTags({ tags }: CollectionTagsProps) {
  const tag = getProductTag(tags, PRODUCT_COLOUR_TAGS)

  if (!tag) return null

  return (
    <Badge
      classes={styles.CollectionTags}
      title={tag}
      themeColour={getBadgeTheme(tag)}
      small
    />
  )
}

export default CollectionTags
